exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".resource-filter-header .ant-form-item-label label{width:120px}", ""]);

// exports
